function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "variant"],
  _excluded2 = ["variant"],
  _excluded3 = ["isLast"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { ChevronRight } from '@procore/core-icons';
import React from 'react';
import { useI18nContext } from '../_hooks/I18n';
import { addSubcomponents } from '../_utils/addSubcomponents';
import { StyledContainer, StyledCrumb, StyledList, StyledSeparator } from './Breadcrumbs.styles';
import { BreadcrumbVariants } from './Breadcrumbs.types';
var separator = /*#__PURE__*/React.createElement(StyledSeparator, {
  "aria-hidden": true
}, /*#__PURE__*/React.createElement(ChevronRight, null));
var Breadcrumbs_ = /*#__PURE__*/React.forwardRef(function Breadcrumbs(_ref, ref) {
  var children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? BreadcrumbVariants.LEGACY : _ref$variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var i18n = useI18nContext();
  var childrenArray = React.Children.toArray(children);
  var isLegacy = variant === BreadcrumbVariants.LEGACY;
  var navigationList = childrenArray.filter(function (child) {
    return child;
  }).map(function (child, i) {
    var isLast = i === childrenArray.length - 1;
    var aria = {
      'aria-current': child.props.active || undefined
    };
    var cloneProps = isLegacy ? aria : _objectSpread(_objectSpread({}, aria), {}, {
      isLast: isLast,
      variant: variant
    });
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: "separator-".concat(i)
    }, /*#__PURE__*/React.cloneElement(child, cloneProps), isLegacy && !isLast ? separator : /*#__PURE__*/React.createElement(React.Fragment, null));
  });
  return /*#__PURE__*/React.createElement(StyledContainer, _extends({
    "aria-label": i18n.t('core.breadcrumbs.label')
  }, props, {
    ref: ref
  }), !isLegacy ? /*#__PURE__*/React.createElement(StyledList, null, navigationList) : navigationList);
});
export var Crumb = /*#__PURE__*/React.forwardRef(function Crumb(_ref2, ref) {
  var _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? BreadcrumbVariants.LEGACY : _ref2$variant,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var childrenWithAriaAttrs = React.Children.toArray(props.children).filter(function (child) {
    return child;
  }).map(function (child) {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      return /*#__PURE__*/React.cloneElement(child, {
        'aria-current': props.active || undefined
      });
    } else {
      return child;
    }
  });
  var isLegacy = variant === BreadcrumbVariants.LEGACY;
  var showSeparator = !isLegacy && props.hasOwnProperty('isLast') && !props.isLast;
  var isLast = props.isLast,
    crumbProps = _objectWithoutProperties(props, _excluded3);
  return /*#__PURE__*/React.createElement(StyledCrumb, _extends({
    as: isLegacy ? 'div' : 'li'
  }, crumbProps, {
    ref: ref
  }), childrenWithAriaAttrs, showSeparator ? separator : /*#__PURE__*/React.createElement(React.Fragment, null));
});
Breadcrumbs_.displayName = 'Breadcrumbs';
Crumb.displayName = 'Breadcrumbs.Crumb';

//  * @codemod npx ...
//  * @deprecatedSince 12.x.x
/**
 * @description  We use breadcrumbs to provide navigational information to the user on every
 * tool’s child page in Procore. The last element is the active view.
 *
 * __Important!__ Prior versions support placing an anchor element in-between `Breadcrumbs` and
 * `Breadcrumbs.Crumb` elements; going forward anchor elements must be inside `Breadcrumbs.Crumb`.
 *
 * Additionally __set `variant="list"` to enable list markup__, it will eventually be the default
 * but requires users to place hyperlinks inside the `Breadcrumbs.Crumb` (`li`) to be proper HTML.

BEFORE:
```
<Breadcrumbs>
  <a href="#">
    <Breadcrumbs.Crumb>Deprecated</Breadcrumbs.Crumb>
  </a>
</Breadcrumbs>
```

AFTER:
```
<Breadcrumbs variant="list">
  <Breadcrumbs.Crumb>
    <a href="#">Standard</a>
  </Breadcrumbs.Crumb>
</Breadcrumbs>
```

 @a11y Use `variant="list"` for semantic `ol`, `li` elements in addition to `nav`. When multiple
 breadcrumbs are in view, it is recommended each have an `aria-label` or `aria-labelledby`.

 @example
  <Breadcrumbs variant="list">
    <Breadcrumbs.Crumb>
      <a href="#">List Items</a>
    </Breadcrumbs.Crumb>
    <Breadcrumbs.Crumb active>
      Current Item
    <Breadcrumbs.Crumb>
  </Breadcrumbs>

 @since 10.19.0

 @see [Storybook](https://stories.core.procore.com/?path=/story/core-react_demos-breadcrumbs--demo)

 @see [Design Guidelines](https://design.procore.com/breadcrumb)

 */
export var Breadcrumbs = addSubcomponents({
  Crumb: Crumb
}, Breadcrumbs_);
//# sourceMappingURL=Breadcrumbs.js.map